import Container from './BookmarkActionsDropdown.container';
import BookmarkActionsDropdown from './BookmarkActionsDropdown';

export default Container(BookmarkActionsDropdown);
